<template>
    <div
        id="assetMessage"
        :style="{ ...messageColors, ...(extendedStyle || {}) }"
        class="sc-message--text"
        v-if="getSrc()"
    >
        <div class="media-content-wrapper">
            <a
                :href="getSrc()"
                download
                target="_blank"
                v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                content="Dosyayı indir"
            >
                <div v-if="getExt()" :class="`fi-${getExt()}`" class="fi">
                    <div class="fi-content" v-if="!isFilterAsset">{{ getExt() }}</div>
                    <div class="fi-content" v-if="isFilterAsset">
                        <div id="fi-data">
                            <p>{{ $t("message.type") }} : {{ getExt() }}</p>
                            <p>{{ $t("message.sender") }} : {{ !!message.raw ? message.raw.user.name : "" }}</p>
                        </div>
                    </div>
                </div>
                <a-icon type="cloud-download" v-else />
                <p class="asset-text">{{ getAssetName() }}</p>
            </a>
        </div>

        <span
            v-if="!message.isMail && message.data.meta"
            :class="message.author === 'me' ? 'received' : 'sent'"
            class="sc-message--meta"
            >{{ message.data.meta }}</span
        >
    </div>
</template>

<script>
import log2 from "../../../utils/log2";

const log = log2("AssetMessage");
export default {
    name: "AssetMessage",
    props: {
        message: {
            type: Object,
            required: true,
        },
        extendedStyle: {
            type: Object,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        isFilterAsset: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        getAssetName() {
            const assetName = this.message?.raw?.asset?.name || "Dosyayı indir";
            return assetName;
        },
        getExt() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message.ext;
            } else {
                asset = this.message.raw.asset.ext;
            }
            return asset;
        },
        getSrc() {
            let asset = "";
            if (!!this.message.isMail) {
                asset = this.message;
            } else {
                asset = this.message.raw.asset;
            }
            const path = asset?.path;

            if (path) {
                const isWhatsapp = path.indexOf("whatsapp") !== -1;
                const isInstagram = path.indexOf("instagram") !== -1;
                const isTelegram = path.indexOf("telegram") !== -1;

                const src =
                    isWhatsapp || isInstagram || isTelegram
                        ? `https://static.supsis.live/${path}`
                        : `https://static.supsis.live/${path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
                log("src", src);
                return src;
            } else {
                log("src path not found", this.message?.raw?.asset);
                return null;
            }
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import "~css-file-icons";

#assetMessage {
    .media-content-wrapper {
        margin: 4px;

        a {
            display: flex;
            gap: 5px;
            flex-direction: row;
            align-items: center;
            padding: 5px;

            &:hover {
                p {
                    border-bottom: 1px solid #000;
                }
            }

            p {
                border-bottom: 1px solid transparent;
                margin-bottom: 0;
            }
        }

        .media-content-text {
            margin-bottom: 0;
            font-family: Poppins, monospace;
            margin-top: 6px;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
        }
    }

    .received {
        color: #222222;
    }

    .sent {
        color: #ffffff;
    }

    .fi-content {
        width: auto;
        font-size: 11px;
    }

    #fi-data {
        position: absolute;
        color: black;
        left: 40px;
        top: -6px;
        font-size: x-small;
        width: max-content;
        display: flex;
        flex-direction: column-reverse;
        line-height: 10px;
    }
}
</style>
